import React, { useState } from 'react';
import VipAdvertItem from '../../main/items/vip_advert_item';
import { Link } from 'react-router-dom';
import rightArrowIcon from '../../../assets/icons/right_arrow.svg';
import { t } from 'i18next';

const AuthorAdsResponsive = ({ ads = [] }) => {
    const [currentPage, setCurrentPage] = useState(0);
    const itemsPerPage = 4;

    const totalPages = Math.ceil(ads.length / itemsPerPage);

    const currentAds = ads.slice(
        currentPage * itemsPerPage,
        (currentPage + 1) * itemsPerPage
    );

    const handleNext = () => {
        if (currentPage < totalPages - 1) setCurrentPage(prev => prev + 1);
    };

    const handlePrevious = () => {
        if (currentPage > 0) setCurrentPage(prev => prev - 1);
    };

    return (
        <div className="mt-[120px] md:mt-[50px] mb-[85px] md:mb-0 w-full flex flex-col author_ads_container px-5">

            {/* Header */}
            <div className="flex justify-between items-center w-full mb-5">
                <h2 className="text-[36px] md:text-2xl font-bold text-[#222222] m-0">
                    {t('otherUserAnnouncements')}
                </h2>

                <div className="flex gap-[10px] md:flex hidden">
                    <button
                        className="bg-white border border-[#D4D4D4] rounded-full h-[44px] w-[44px] flex justify-center items-center"
                        onClick={handlePrevious}
                        disabled={currentPage === 0}
                    >
                        <img src={rightArrowIcon} alt="Left" className="rotate-180" />
                    </button>

                    <button
                        className="bg-white border border-[#D4D4D4] rounded-full h-[44px] w-[44px] flex justify-center items-center"
                        onClick={handleNext}
                        disabled={currentPage === totalPages - 1}
                    >
                        <img src={rightArrowIcon} alt="Right" />
                    </button>
                </div>
            </div>

            {/* Ads container FLEX */}
            <div className="flex flex-wrap gap-5 w-full">

                {currentAds.length > 0 ? (
                    currentAds.map(ad => (
                        <div
                            key={ad.id}
                            className="w-[calc(50%-10px)] md:w-[calc(25%-15px)]"
                        >
                            <Link to={`/announcement/${ad.id}`}>
                                <VipAdvertItem
                                    id={ad.id}
                                    imagePath={ad.image_url || ad.main_image_url || ''}
                                    name={ad.title}
                                    price={ad.price}
                                    price_type={ad.price_type}
                                    is_negotiable={ad.is_negotiable || ad.negotiable}
                                    barter={ad.barter}
                                    location={ad.location || { province: ad.city || '', locality: ad.city || '' }}
                                    date={ad.created_at || ad.date}
                                    is_favorite={ad.is_favorite || false}
                                />
                            </Link>
                        </div>
                    ))
                ) : (
                    <p className="text-gray-500 w-full text-center">Объявлений нет.</p>
                )}

            </div>

            {/* Mobile navigation */}
            {totalPages > 1 && (
                <div className="flex md:hidden items-center justify-center w-full mt-4 gap-4">
                    <button
                        className="rounded-full h-10 w-10 flex justify-center items-center"
                        onClick={handlePrevious}
                        disabled={currentPage === 0}
                    >
                        <img src={rightArrowIcon} alt="Left" className="rotate-180 w-4 h-4" />
                    </button>

                    <span className="text-sm font-medium text-[#222222]">
                        {currentPage + 1} / {totalPages}
                    </span>

                    <button
                        className="rounded-full h-10 w-10 flex justify-center items-center"
                        onClick={handleNext}
                        disabled={currentPage === totalPages - 1}
                    >
                        <img src={rightArrowIcon} alt="Right" className="w-4 h-4" />
                    </button>
                </div>
            )}
        </div>
    );
};

export default AuthorAdsResponsive;